import { render, staticRenderFns } from "./DocumentTemplate.vue?vue&type=template&id=ceeb9e62&scoped=true&"
import script from "./DocumentTemplate.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeb9e62",
  null
  
)

export default component.exports